module.exports = __webpack_public_path__ + "img/icon-16-back-right.fb710c10.svg";